/** Carry a web funnel code through a verified OneLink after an App Store install. */
export function appStoreDestination(storeUrl: string, oneLinkUrl: string, search: string): string {
  if (new URLSearchParams(search).get('qz') !== 'fc1') return storeUrl;
  try {
    const link = new URL(oneLinkUrl);
    if (link.protocol !== 'https:' || link.username || link.password) return storeUrl;
    link.searchParams.set('af_sub1', 'fc1');
    return link.toString();
  } catch {
    return storeUrl;
  }
}
